// Central site data & config
export const EVENT = {
  name: "Grimsby On The Lake Turkey Trot",
  shortName: "Turkey Trot",
  date: "2026-10-10T07:30:00-04:00",
  dateLabel: "October 10, 2026",
  charity: "Inclusion West Niagara",
  location: {
    name: "Casablanca Beach",
    address: "565 N Service Rd, Grimsby, ON",
    maps: "https://www.google.com/maps?q=43.20863,-79.59272(Turkey+Trot+Start+Line)&z=17&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=565+N+Service+Rd,+Grimsby,+ON",
  },
  parking: {
    name: "Church on Hunter",
    address: "321 Hunter Rd, Grimsby, ON L3M 0H2",
    maps: "https://www.google.com/maps?q=Church+on+Hunter,+321+Hunter+Rd,+Grimsby,+ON&z=16&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=Church+on+Hunter,+321+Hunter+Rd,+Grimsby,+ON",
  },
};

// External links
export const LINKS = {
  register: "https://raceroster.com/events/2026/140354/grimsby-on-the-lake-turkey-trot",
  donate: "https://inclusionwestniagara.ca/",
  instagram: "https://www.instagram.com/grimsbyturkeytrot",
  results: "https://www.splitstiming.com/results/event.php?event=grimsby-turkey-trot",
  photos: "https://aperturestudio.wetransfer.com/previews/a68b36e82d627009a9817930a307c11820261011230133/5c6d2452d2fa80a72011617873e50bc320261012003154/83a1db",
};

export const CHARITY_URL = "https://inclusionwestniagara.ca/";
export const OWNER_EMAIL = "grimsbyturkeytrot@gmail.com";
export const OWNER_PHONE = "9058705823";
export const OWNER_PHONE_DISPLAY = "(905) 870-5823";

export const LOGO = `${process.env.PUBLIC_URL}/media/logo.png?v=4`;
export const AO_BADGE = `${process.env.PUBLIC_URL}/media/ao-sanctioned.png`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Registration", to: "/registration" },
  { label: "Donate", to: "/sponsor-donation" },
  { label: "About", to: "/about" },
  { label: "Schedule", to: "/schedule" },
  { label: "Race Map", to: "/race-map" },
  { label: "Sponsors", to: "/sponsors" },
  { label: "Volunteer", to: "/volunteer" },
  { label: "Gallery", to: "/gallery" },
  { label: "Results", to: "/results" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const SCHEDULE = [
  { time: "7:30 AM", title: "Bib Pickup Opens", desc: "Grab your race kit, timing chip and cheer on friends at Casablanca Beach." },
  { time: "8:45 AM", title: "Kids 1 km Dash", desc: "Our littlest trotters take the lead. Every kid gets a big cheer at the finish line." },
  { time: "9:00 AM", title: "5 km Run / Walk", desc: "The main event along the shoreline, run it, walk it, or stroll with the family." },
  { time: "10:30 AM", title: "Awards & Celebration", desc: "Age group medals for the 5 km, post-race snacks for an energy boost, and a cheer for every finisher." },
];

export const HIGHLIGHTS = [
  { title: "Chip-Timed 5 km", desc: "Accurate results along a flat, scenic lakeside course.", price: "$65" },
  { title: "Kids 1 km Dash", desc: "A safe, fun run for ages 4–12 with a free event t-shirt for all.", price: "$20" },
  { title: "Every Dollar Gives Back", desc: "100% of proceeds support Inclusion West Niagara." },
];

export const IMAGES = {
  grimsby: "https://customer-assets-lxgj4vgw.emergentagent.net/job_trot-for-inclusion/artifacts/mwrupgp8_fe43cb0772a98f49542ba0db8504cd39_blob%20%281%29.webp",
  hero: `${process.env.PUBLIC_URL}/media/hero-runner.jpg`,
  course: "https://images.unsplash.com/photo-1673733223122-f588871900e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxhdXR1bW4lMjBwYXJrJTIwcnVubmVyfGVufDB8fHx8MTc4NTgxODMyMXww&ixlib=rb-4.1.0&q=85",
  kids: "https://images.unsplash.com/photo-1623604407437-d8fce3bc61de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxraWRzJTIwZnVuJTIwcnVufGVufDB8fHx8MTc4NTgxODMyNnww&ixlib=rb-4.1.0&q=85",
  charity: "https://images.unsplash.com/photo-1724344526531-5168ab8b034b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxhdXR1bW4lMjBjaGFyaXR5JTIwY29tbXVuaXR5fGVufDB8fHx8MTc4NTgxODMzMXww&ixlib=rb-4.1.0&q=85",
  leaves: "https://images.unsplash.com/photo-1516700675895-b2e35cae333c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxhdXR1bW4lMjBjaGFyaXR5JTIwY29tbXVuaXR5fGVufDB8fHx8MTc4NTgxODMzMXww&ixlib=rb-4.1.0&q=85",
  gallery: [
    "https://images.unsplash.com/photo-1745790289741-12a211a8325d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxhdXR1bW4lMjBmdW4lMjBydW4lMjBjaGFyaXR5JTIwcmFjZSUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODU4MTg0MzJ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1667781838690-5f32ea0ccea6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxhdXR1bW4lMjBmdW4lMjBydW4lMjBjaGFyaXR5JTIwcmFjZSUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODU4MTg0MzJ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/35135977/pexels-photo-35135977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/2168291/pexels-photo-2168291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1513276193780-64b881470da8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxhdXR1bW4lMjBmdW4lMjBydW4lMjBjaGFyaXR5JTIwcmFjZSUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODU4MTg0MzJ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1667781743417-a8099056261c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxhdXR1bW4lMjBmdW4lMjBydW4lMjBjaGFyaXR5JTIwcmFjZSUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODU4MTg0MzJ8MA&ixlib=rb-4.1.0&q=85",
  ],
};

export const SPONSORS = [
  {
    name: "Aperture",
    tier: "Official Media Sponsor",
    logo: `${process.env.PUBLIC_URL}/media/sponsor-aperture.png`,
    url: "https://joinaperture.webflow.io/",
  },
  {
    name: "Norstar Windows & Doors Ltd.",
    tier: "Community Sponsor",
    logo: `${process.env.PUBLIC_URL}/media/sponsor-norstar.png`,
    url: "https://www.norstarwindows.com/",
  },
  {
    name: "Strength Collective",
    tier: "Community Sponsor",
    logo: `${process.env.PUBLIC_URL}/media/sponsor-strength-collective.png`,
    url: "https://www.strengthcogrimsby.com/",
  },
  {
    name: "spaceless",
    tier: "Community Sponsor",
    logo: `${process.env.PUBLIC_URL}/media/sponsor-spaceless.png`,
    url: "https://www.spacelessmarketing.com/",
  },
  {
    name: "Harmony Jewellers",
    tier: "Community Sponsor",
    logo: `${process.env.PUBLIC_URL}/media/sponsor-harmony-jewellers.png`,
    url: "https://harmonyjewellers.ca/",
  },
];

export const FAQS = [
  { q: "When and where is the Turkey Trot?", a: "Saturday, October 10, 2026 at Casablanca Beach, 565 N Service Rd, Grimsby, ON. Bib pickup opens at 7:30 AM." },
  { q: "What distances are offered?", a: "A chip-timed 5 km Run/Walk (9:00 AM) and a Kids 1 km Dash (8:45 AM) for ages 4–12." },
  { q: "Can I walk the 5 km?", a: "Absolutely! The 5 km is a Run/Walk, walkers, strollers and families are all welcome." },
  { q: "Where does the money go?", a: "100% of net proceeds support Inclusion West Niagara, empowering people of all abilities across our community." },
  { q: "Is there day-of registration?", a: "Yes, subject to availability. We strongly recommend registering online in advance to guarantee your race kit and shirt." },
  { q: "Where do I park?", a: "Free race-day parking is available at Church on Hunter, 321 Hunter Rd, Grimsby, a short walk from the start line at Casablanca Beach. See the Race Map page for a pin and directions." },
  { q: "Are dogs allowed?", a: "Leashed, friendly dogs are welcome at the walk. Please keep them to the back of the pack for everyone's safety." },
  { q: "What if it rains?", a: "The Turkey Trot runs rain or shine. In case of severe weather, updates will be posted here and emailed to registrants." },
];

export const RESULTS = [
  { place: 1, name: "Jordan Mercer", cat: "5 km Overall", time: "17:42", pace: "3:32/km" },
  { place: 2, name: "Priya Sharma", cat: "5 km Overall", time: "18:05", pace: "3:37/km" },
  { place: 3, name: "Liam O'Connor", cat: "5 km Overall", time: "18:31", pace: "3:42/km" },
  { place: 1, name: "Ava Thompson", cat: "5 km Women", time: "19:14", pace: "3:51/km" },
  { place: 1, name: "Noah Bélanger", cat: "5 km 40-49", time: "19:48", pace: "3:58/km" },
  { place: 1, name: "Maya Singh", cat: "Kids 1 km", time: "4:38", pace: "4:38/km" },
];
